import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />

    <Tooltip anchorSelect=".paiement-class" place="top">
      <button className="text-xs font-bold">Paiement</button>
    </Tooltip>
    <Tooltip anchorSelect=".imprimer-class" place="top">
      <button className="text-xs font-bold">Contrat</button>
    </Tooltip>
    <Tooltip anchorSelect=".update-class" place="top">
      <button className="text-xs font-bold">Modifier</button>
    </Tooltip>
    <Tooltip anchorSelect=".delete-class" place="top">
      <button className="text-xs font-bold">Supprimer</button>
    </Tooltip>
    <Tooltip anchorSelect=".contrat-class" place="top">
      <button className="text-xs font-bold">Contrats</button>
    </Tooltip>
    <Tooltip anchorSelect=".declaration-class" place="top">
      <button className="text-xs font-bold">Déclaration</button>
    </Tooltip>
    <Tooltip anchorSelect=".factures-class" place="top">
      <button className="text-xs font-bold">Facture</button>
    </Tooltip>
    <Tooltip anchorSelect=".return-class" place="top">
      <button className="text-xs font-bold">Retour</button>
    </Tooltip>
    <Tooltip anchorSelect=".validreturn-class" place="top">
      <button className="text-xs font-bold">Valide ce retour</button>
    </Tooltip>
    <Tooltip anchorSelect=".history-class" place="top">
      <button className="text-xs font-bold">Historique</button>
    </Tooltip>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
